import { Component, Injectable, OnInit } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { NavController } from '@ionic/angular';
import { asyncScheduler, Subscription } from 'rxjs';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.page.html',
  styleUrls: ['./splash-screen.page.scss'],
})
export class SplashScreenPage implements OnInit {

  private splashSubscription: Subscription = new Subscription();

  constructor(
    private splashAccessGuard: SplashAccessGuard,
    private navCtrl: NavController
  ) { }

  ngOnInit() {
    if (!Capacitor.isNativePlatform()) this.splashSubscription = asyncScheduler.schedule(() => this.navCtrl.navigateForward(['/home']), 5000);
  }

  ionViewWillLeave() {
    this.splashAccessGuard.blockAccess();
  }

  ngOnDestroy() {
    if (this.splashSubscription) this.splashSubscription.unsubscribe();
  }

}

// splash-access.guard.ts
@Injectable({ providedIn: 'root' })
export class SplashAccessGuard implements CanActivate, CanLoad {
  private canPass = true;

  // Método para bloquear después
  public blockAccess() {
    this.canPass = false;
  }

  canActivate(): boolean {
    return this.canPass;
  }

  canLoad(): boolean {
    return this.canPass;
  }
}